import {Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const EmptySection = (props: {title: string}) => {
  return (
    <EmptyWrapper>
      <Text color="Grey0" size="px10" transform="uppercase">
        {props.title}
      </Text>
    </EmptyWrapper>
  );
};

const EmptyWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
